import { Box } from "@mui/material";
import React from "react";
import { FontStyle } from "../constants";

const styles = {
  float: {
    position: "fixed",
    top: "0px",
    left: "0px",
    zIndex: "100",
    width: "100vw",
    backgroundColor: "#00000080",
    height: "100vh",
  },
  videoStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    // width: "1280px",
    // width: '404px',
    // maxWidth: '100%',
    // height: "720px",
    width: "40vh",
    height: "70vh",

    // width: "100%",
    // height: 'auto',
    // height: '178.98%',
    // pointerEvents: 'none',
    // transform: 'translate(-50%, -50%)',
  },
  closeButton: {
    position: "absolute",
    top: "0px",
    right: "0px",
    padding: "2rem",
    cursor: "pointer",
    color: "white",
    fontSize: "2rem",
    lineHeight: "0",
    ...FontStyle.body,
  },
};
const srcOptions = "enablejsapi";

const FloatingPlayer = ({ src, setSrc }) => {
  const fullSrc = `https://www.youtube.com/embed/${src}?` + srcOptions;
  return (
    <Box sx={styles.float} onClick={() => setSrc("")}>
      <Box sx={styles.closeButton} onClick={() => setSrc("")}>
        x
      </Box>
      <iframe
        style={styles.videoStyle}
        src={fullSrc}
        title="YouTube video player"
        allow="autoplay;"
        frameBorder="0"
      />
    </Box>
  );
};

export default FloatingPlayer;
